module.exports = __webpack_public_path__ + "static/media/logo.b0a07311.png";